import React from 'react';
import PropTypes from 'prop-types';

import QueryString from 'query-string';

import SearchService from '../../services/SearchService';

import SearchField from './SearchField';
import SearchResults from './SearchResults';
import SearchPager from './SearchPager';

class Search extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searched: false,
            query: '',
            offset: 0,
            amount: 0,
            total: 0,
            items: [],
        };
    }

    componentDidMount = () => {
        window.addEventListener('popstate', this.fetchStateFromUrlAndSearch);
        this.fetchStateFromUrlAndSearch();
    };

    fetchStateFromUrlAndSearch = async () => {
        const {
            query,
            offset,
            amount,
        } = QueryString.parse(window.location.search);

        const response = await SearchService.search(query, offset, amount);
        this.setState({
            searched: !!query,
            query: query || '',
            offset: offset || 0,
            amount: amount || 20,
            total: response.total || 0,
            items: response.results || [],
        });

        const firstCard = document.querySelector('.card-list .card:first-child');

        if (firstCard) {
            firstCard.scrollIntoView({
                behavior: 'smooth',
            });
        }
    };

    handleUpdateQuery = (query) => {
        this.setState({
            query,
            offset: 0,
        });
    };

    handleUpdateOffset = (offset) => {
        this.setState({
            offset,
        }, this.handleSearch);
    };

    handleSearch = async () => {
        const {
            query,
            offset,
            amount,
        } = this.state;

        const base = window.location.toString().split('?')[0];
        const search = QueryString.stringify({
            query,
            offset,
            amount,
        });

        // Update the query string of URLs in the language selector
        [...document.querySelectorAll('.lang-switch__item a')].forEach((el) => {
            el.search = `?${search}`; // eslint-disable-line no-param-reassign
        });

        history.pushState({}, '', `${base}?${search}`); // eslint-disable-line no-restricted-globals
        this.fetchStateFromUrlAndSearch();
    };

    render = () => {
        const {
            searched,
            query,
            total,
            items,
            offset,
            amount,
        } = this.state;

        const {
            title,
            buttonLabel,
            notFoundMessage,
            readMore,
            previousLabel,
            nextLabel,
        } = this.props;

        return (
            <React.Fragment>
                <div className="hero is-simple">
                    <div className="hero__content container is-vertical is-horizontal">
                        <div className="block">
                            <h1 className="hero__title has-padding">{title}</h1>
                            <SearchField
                                query={query}
                                handleUpdateQuery={this.handleUpdateQuery}
                                handleSearch={this.handleSearch}
                                buttonLabel={buttonLabel}
                            />
                        </div>
                    </div>
                </div>
                {searched &&
                    <div className="container is-horizontal is-vertical search-container">
                        <div className="text-container">
                            <SearchResults
                                searched={searched}
                                items={items}
                                notFoundMessage={notFoundMessage}
                                readMore={readMore}
                            />
                            <SearchPager
                                total={parseInt(total, 10)}
                                offset={parseInt(offset, 10)}
                                amount={parseInt(amount, 10)}
                                handleUpdateOffset={this.handleUpdateOffset}
                                previousLabel={previousLabel}
                                nextLabel={nextLabel}
                            />
                        </div>
                    </div>
                }
            </React.Fragment>
        );
    };
}

Search.propTypes = {
    title: PropTypes.string.isRequired,
    buttonLabel: PropTypes.string.isRequired,
    notFoundMessage: PropTypes.string.isRequired,
    readMore: PropTypes.string.isRequired,
    previousLabel: PropTypes.string.isRequired,
    nextLabel: PropTypes.string.isRequired,
};

export default Search;
